import { useEffect } from 'react';

/**
 * In development only: connects to the local sync-server SSE endpoint.
 * When the sync server fires a 'reload' event (after git pull), reloads the page
 * so fresh articles.json / charts.json are picked up immediately.
 */
export function useSyncReload() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    let es: EventSource | null = null;
    let retryTimeout: ReturnType<typeof setTimeout>;

    const connect = () => {
      try {
        es = new EventSource('http://localhost:3003/reload-events');
        es.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            if (msg.type === 'reload') {
              console.log('[sync-reload] Reload triggered by sync server');
              window.location.reload();
            }
          } catch { /* ignore parse errors */ }
        };
        es.onerror = () => {
          es?.close();
          // Retry connection after 5s if sync server restarts
          retryTimeout = setTimeout(connect, 5000);
        };
      } catch { /* SSE not available */ }
    };

    connect();
    return () => { es?.close(); clearTimeout(retryTimeout); };
  }, []);
}
